const CHAT_EXTENSION_LAB_ROUTE = /^\/(en|ru|ua|de|pt)\/chat-extension-lab\/?$/;

/** Exact shared matcher for Express paths and Angular router URLs. */
export function isChatExtensionLabRoute(url: string): boolean {
  const pathname = url.split(/[?#]/, 1)[0] ?? '';
  return CHAT_EXTENSION_LAB_ROUTE.test(pathname);
}

/** Builder embeds share the same chrome and exact framing boundary. */
export function isWorkflowEmbeddedRoute(url: string): boolean {
  return isChatExtensionLabRoute(url) || /^\/(en|ru|ua|de|pt)\/extension-publication-preview\/?$/.test(url.split(/[?#]/, 1)[0] ?? '');
}
